import Textarea from "../../components/inputs/Textarea";
import MonthInput from "../../components/MonthInput";
import Button from "../../components/buttons/Button";

const University = props => {
  const { data, setData } = props;
  const { errors, setError, next, btnLabel, saved, loading, signUp } = props;

  const verifyData = () => {
    setError();
    let isOkay = true;

    if (!data["need_design"]) {
      setError({
        field: "need_design",
        message:
          "Please provide a correct description of your need in term of design",
      });
      isOkay = false;
    }
    if (!data["need"]) {
      setError({
        field: "need",
        message:
          "Please provide a correct description of your need to validate",
      });
      isOkay = false;
    }
    if (data["start_date"] && !isDateValid(data["start_date"])) {
      setError({
        field: "start_date",
        message: "Please check start date",
      });
      isOkay = false;
    }

    if (data["end_date"] && !isDateValid(data["end_date"])) {
      setError({
        field: "end_date",
        message: "Please check end date",
      });
      isOkay = false;
    }

    if (!data["design_outcomes"]) {
      setError({
        field: "design_outcomes",
        message:
          "Please provide your design need and the expected outcomes/deliverables",
      });
      isOkay = false;
    }

    if (isOkay) next();
  };

  return (
    <div className="oUserForm">
      <h3>Your design Challenge</h3>
      {signUp && (
        <div className="oUserForm_inputs">
          <Textarea
            label="What are your current obstacles and how can design help you overcome them?"
            required
            max={500}
            value={data["need_design"]}
            setValue={value => setData({ field: "need_design", value })}
            error={errors.some(({ field }) => field === "need_design")}
          />
          <Textarea
            label="Whom do you want to convince? What do you need to validate?"
            required
            max={500}
            value={data["need"]}
            setValue={value => setData({ field: "need", value })}
            error={errors.some(({ field }) => field === "need")}
          />
        </div>
      )}
      <div className="oUserForm_inputs">
        <Textarea required
          label="Design deliverables and priorities"
          max={1250}
          value={data["design_outcomes"]}
          notice={
            <div>
              Describe your design need and the expected outcomes/deliverables?
              <br />
              Amongst all your design needs what is the most important to you to
              achieve?
            </div>
          }
          setValue={value => setData({ field: "design_outcomes", value })}
          error={errors.some(({ field }) => field === "design_outcomes")}
        />
        <div style={{ margin: "4rem 0" }}>
          <h5>Timeline</h5>
          <p className="text -small">
            What are your target start and end dates?
          </p>
          <div style={{ marginTop: "2rem" }}>
            <MonthInput
              value={data["start_date"]}
              setValue={value => setData({ field: "start_date", value })}
              label="Start"
              error={errors.some(({ field }) => field === "start_date")}
            />
          </div>
          <div style={{ marginTop: "1rem" }}>
            <MonthInput
              value={data["end_date"]}
              setValue={value => setData({ field: "end_date", value })}
              label="End"
              error={errors.some(({ field }) => field === "end_date")}
            />
          </div>
        </div>
        <Textarea
          label="Other funding"
          max={1250}
          value={data["other_funding"]}
          notice={
            <div>
              Mention any other funding from third party sources that you have
              received or are applying to.
              <br />
              Why is it not used for this purpose?
            </div>
          }
          setValue={value => setData({ field: "other_funding", value })}
          error={errors.some(({ field }) => field === "other_funding")}
        />
      </div>
      {saved ? (
        <Button big green full>
          Saved !
        </Button>
      ) : (
        <Button onClick={verifyData} big full>
          {loading ? "Registering..." : btnLabel || "Continue"}
        </Button>
      )}
    </div>
  );
};

const isDateValid = rawDate => {
  const [rawYear, rawMonth] = rawDate.split("-");

  const year = parseInt(rawYear);
  if (isNaN(year)) return false;
  else if (year < 2000 || year > 2100) return false;

  const month = parseInt(rawMonth);
  if (isNaN(month)) return false;
  else if (month < 1 || month > 12) return false;

  return true;
};

export default University;
